<template>
  <div class="main-view">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <van-tabbar route style="height: 50px">
      <van-tabbar-item replace to="/signhome/clockin" icon="location-o"
        >打卡</van-tabbar-item
      >
      <van-tabbar-item replace to="/signhome/statistics" icon="chart-trending-o"
        >统计</van-tabbar-item
      >
      <van-tabbar-item
        v-if="userInfo?.websiteManage"
        replace
        to="/signhome/signapprove"
        icon="chart-trending-o"
        >审批</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script setup lang="ts">
import { userAuthStore } from "@/store/auth";

const common = userAuthStore();
const userInfo: any = ref({ ...common.currUserData });
onMounted(async () => {});
</script>
<style scoped>
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
